/* -------------------------------------------------------------------------- */
/*                             Schema Sensor Brands                           */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const sensorBrand = new schema.Entity('sensorBrands', {}, { idAttribute: 'brandId' });
export const sensorBrands = new schema.Array(sensorBrand);
